import { IOption } from '@r1-frontend/ui-react/components/select/creatableSelect';

import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { IAction } from '~/src/store';

const setClientContactPhone = (contactPhone: IOption): IAction<EAction.SetClientContactPhone, { contactPhone: IOption }> => ({
    type: EAction.SetClientContactPhone,
    payload: {
        contactPhone,
    },
});

export default setClientContactPhone;
